module.exports = __webpack_public_path__ + "img/coop_nanemba_e.399e59df.png";